import DashboardWidgetController from 'dashboard/components/dashboard-widget/dashboard-widget-controller';
import * as api from 'dashboard/resources/my-slow-moving-games.api';
import template from './my-slow-moving-games-widget.html';

const mapStateToThis = ({ config, dictionary, session }) => {
  const { instantWidgetsStaleGames, instantWidgetsValidationThreshold } = config;
  const { locale, retailer } = session;
  const terms = dictionary.terms[locale];

  return {
    retailer,
    instantWidgetsStaleGames,
    instantWidgetsValidationThreshold,
    terms,
  };
};

const mapDispatchToThis = {};

// eslint-disable-next-line no-undef
@Inject('$scope', '$ngRedux', '$state')
class MySlowMovingGamesWidgetController extends DashboardWidgetController {
  constructor() {
    super();
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    const retailerId = this.$state.params.retailerNo || this.retailer.retailerId;
    this.loadDataAsync(() => api.fetchMySlowMovingGames(retailerId));
  }

  $onDestroy() {
    this.unsubscribe();
  }
}

export default class MySlowMovingGamesWidgetComponent {
  constructor() {
    this.template = template;
    this.controller = MySlowMovingGamesWidgetController;
    this.bindings = {
      isEditMode: '<',
      isRemovable: '<',
      removeWidget: '&?',
    };
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/my-slow-moving-games/my-slow-moving-games-widget-component.js